import { render, staticRenderFns } from "./MedicalRecordItem.vue?vue&type=template&id=0df7f342&scoped=true&lang=pug&"
import script from "./MedicalRecordItem.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordItem.vue?vue&type=style&index=0&id=0df7f342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7f342",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
